import React, { ReactNode, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Skeleton } from 'antd'

import { ProductIds } from 'core/application/commons/config'
import getAttachmentsApi, {
  Attachment,
} from 'core/application/employeeDashboard/summary/reimbursementRequests/getAttachments'
import getAttachmentsPerksApi from 'core/application/employeeDashboard/summary/reimbursementRequests/getAttachmentsPerksApi'

import Modal from 'common/components/feedback/Modal'
import Button from 'common/components/general/Button'
import Icon from 'common/components/general/Icon'

import { queryRequest } from 'common/RequestUtils'

import useCurrentProduct from '../../hooks/useCurrentProduct'

interface ViewFilesModalProps {
  visible: boolean
  onClose: () => void
  expenseId?: string
}

const ViewAttachmentsModal: React.FC<ViewFilesModalProps> = (props) => {
  const { t: translate } = useTranslation(['ee-dashboard', 'translation'])
  const [attachments, setAttachments] = useState<Attachment[]>([])
  const [loadingAttachments, setLoadingAttachments] = useState<boolean>(false)
  const product = useCurrentProduct()

  useEffect(() => {
    getAttachments()
  }, [props.expenseId])

  const getAttachments = async () => {
    if (props.expenseId !== undefined) {
      setLoadingAttachments(true)
      setAttachments([])
      let result = []
      if (product.productId == ProductIds.Perks) {
        result = await queryRequest(() => getAttachmentsPerksApi(props.expenseId ?? ''))
      } else {
        result = await queryRequest(() => getAttachmentsApi(props.expenseId ?? ''))
      }
      setAttachments(result)
      setLoadingAttachments(false)
    }
  }

  const getAttachmentsContent = (): ReactNode => {
    return attachments.map((item, index) => {
      return (
        <a href={item.fileNameUrl} key={index} className="color-blue-6 mb-4" target="_blank" rel="noopener noreferrer">
          <Icon type="far fa-paperclip" fontAwesome className="mr-8" />
          {item.title}
        </a>
      )
    })
  }

  const modalFooterActions = (
    <Button htmlType="button" onClick={props.onClose} type="default">
      {translate('translation:general.cancel')}
    </Button>
  )

  return (
    <Modal
      title={translate('reimbursement-requests.uploaded-attachments-title')}
      visible={props.visible}
      destroyOnClose
      closable
      onCancel={props.onClose}
      footer={modalFooterActions}
    >
      <Skeleton active loading={loadingAttachments}>
        <div className="flex flex__direction_column">{getAttachmentsContent()}</div>
      </Skeleton>
    </Modal>
  )
}

export default ViewAttachmentsModal
